





































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { FillInfoItemOfForm } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import { CommonModule, UserModule } from '../../../store'
import { disposeFillInfoToParamsForCM, getArrChildForTree, findItemForTree, getAllFatherNodeForTree } from '../../../utils/toolsForCommon'
import { ElMessageComponent } from 'element-ui/types/message'
@Component({
  name: 'MaintainSchoolInfoList',
  mixins: [Pagination],
  components: {
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue')
  }
})
export default class MaintainSchoolInfoList extends Vue {
  public filterText: string = ''
  public informationOverviewBase: Array<FillInfoItemOfForm> = [
    {
      title: '乡镇',
      type: 'text',
      key: 'villagesAndTowns',
      value: '',
      placeholder: '乡镇不可更改',
      content: '',
      disabled: true
    },
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationName',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: true,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '食堂专户名称',
      type: 'text',
      key: 'accountName',
      value: '',
      placeholder: '请输入食堂专户名称',
      content: '',
      isNecessary: true
    },
    {
      title: '食堂专户账号',
      type: 'text',
      key: 'account',
      value: '',
      placeholder: '请输入食堂专户账号',
      content: '',
      isNecessary: true
    },
    {
      title: '开户行',
      type: 'text',
      key: 'depositBank',
      value: '',
      placeholder: '请输入开户行',
      content: '',
      isNecessary: true
    },
    {
      title: '开户行号',
      type: 'text',
      key: 'depositBankCode',
      value: '',
      placeholder: '请输入开户行号',
      content: '',
      isNecessary: true
    },
    {
      title: '转入账户户名',
      type: 'text',
      key: 'receivingAccountName',
      value: '',
      placeholder: '请输入转入账户户名',
      content: '',
      isNecessary: false
    },
    {
      title: '转入账户账号',
      type: 'text',
      key: 'receivingAccount',
      value: '',
      placeholder: '请输入转入账户账号',
      content: '',
      isNecessary: false
    },
    {
      title: '转入账户开户行',
      type: 'text',
      key: 'receivingDepositBank',
      value: '',
      placeholder: '请输入转入账户开户行',
      content: '',
      isNecessary: false
    },
    {
      title: '转入开户行号',
      type: 'text',
      key: 'receivingDepositBankCode',
      value: '',
      placeholder: '请输入转入开户行号',
      content: '',
      isNecessary: false
    }
  ]
  public currentOneDetail: any = {}
  public loadingForUpdateBaseInfo: boolean = false

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this.$refs.tree as any).filter(val)
  }

  async mounted (): Promise<void> {
    await CommonModule.getTreeDataForSubOrganization()
    await CommonModule.getTreeDataForOrganization()
    this.$nextTick(() => {
      const schoolList = getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id)
      ;(this as any).$refs.tree.setCheckedKeys(schoolList.length ? schoolList.slice(0, 1) : [])
      this.getTableDataList()
    })
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  async getTableDataList () {
    try {
      const _that: any = this
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const resultListForTree = (this as any).$refs.tree.getCheckedKeys(true)
      const params = {
        ...pageParams
      }
      const orgId = resultListForTree[0]
      if (resultListForTree.length) {
        Object.assign(params, {
          orgId
        })
      }
      this.loadingForUpdateBaseInfo = true
      const { data: result } = await (this as any).$http.schoolInfoList(params)
      this.loadingForUpdateBaseInfo = false
      if (result.code !== 200) return this.$message.error(result.msg)
      const resultListForQuery = ((result.data && result.data.records) || [])
      const info = resultListForQuery[0] || {}
      this.currentOneDetail = info
      // 如果没有详情的情况下，乡镇和学校是一定要有的：
      if (!Object.keys(this.currentOneDetail).length) {
        info.orgId = orgId
      }
      this.informationOverviewBase = this.informationOverviewBase.map(item => {
        const { key } = item
        switch (key) {
          case 'villagesAndTowns':
            if (info['orgId']) {
              const schoolAllFather = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
              const idForTown = schoolAllFather[schoolAllFather.length - 2]
              if (idForTown) {
                const resForTown = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForTown)
                if (resForTown) {
                  item.value = (resForTown as any).name
                  item.content = (resForTown as any).name
                }
              }
            }
            break
          case 'organizationName':
            if (info['orgId']) {
              item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
              item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
            }
            item.content = item.temporaryStorageForValue.name
            break
          default:
            item.value = info[key] || ''
            item.content = info[key] || ''
            break
        }
        item['editShow'] = false
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  handleCheckChange (): void {
    this.getTableDataList()
  }

  // tree单选：
  handleCheckChangeReal (data, checkbox) {
    const treeDom = (this as any).$refs.tree
    if (checkbox) {
      treeDom.setCheckedKeys([data.id])
    }
  }

  operationForClickForUpdateBaseInfo (item) {
    this.informationOverviewBase = this.informationOverviewBase.map(v => {
      if (v.key === item.key) {
        v['editShow'] = true
      } else {
        v['editShow'] = false
      }
      v.value = v.content
      return v
    })
  }

  operationForClickForCancelUpdateBaseInfo () {
    this.informationOverviewBase = this.informationOverviewBase.map(v => {
      v['editShow'] = false
      v.value = v.content
      return v
    })
  }

  async saveForUpdateBaseInfo (): Promise<ElMessageComponent | void> {
    try {
      // let whoEmpty = null
      // const isEmpty = this.informationOverviewBase.some(item => {
      //   if (item.value === '' && item.isNecessary) {
      //     whoEmpty = item
      //     return true
      //   }
      // })
      // if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      const params = disposeFillInfoToParamsForCM(this.informationOverviewBase)
      const { id } = this.currentOneDetail
      if (id) Object.assign(params, { id })
      this.loadingForUpdateBaseInfo = true
      const { data: result } = await (this as any).$http.capitalInfoSave(params)
      this.loadingForUpdateBaseInfo = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`基本信息更新成功`)
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }
}
